export default __webpack_public_path__ + "static/media/arrow-down.27b169d9.svg";